import React from 'react';

import {
  Button,
  Grid
} from '@mui/material';
import {
  Form,
  fields,
  formUtil,
  validationUtil
} from 'iron-forge-react-modules';

import { BaseWidget } from 'modules/layer01';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [saveCustomFields, saveCustomFieldsTuple] = dataService.useSaveCustomFields(props.storeId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      additionalSupportText: '',
      creditCardDynamicDescriptor: '',
      zenDeskUrl: ''
    }
  });
  formUtil.useSetFormFields(queryTuple, form.setValue, [
    'additionalSupportText',
    'creditCardDynamicDescriptor',
    'zenDeskUrl'
  ]);



  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      saveCustomFields(formState);
    },
    [saveCustomFields]
  );

  const loading = queryTuple.loading || saveCustomFieldsTuple.loading;

  return (
    <Form.FC
      disableDefaultOverflow
      onSubmit={form.handleSubmit(processSubmit)}>

      <BaseWidget.FC
        title="Custom Fields"
        elAction={(
          <Button
            disabled={loading}
            type="submit"
            variant="contained">
            Save
          </Button>
        )}>
        <Grid
          container
          spacing={2}>
          <Grid
            item
            xs={12}
            md={6}>
            <ControlledTextField
              isDisabled={loading}
              disableDefaultMargins
              label="Credit Card Dynamic Descriptor"
              formControl={form.control}
              fieldKey="creditCardDynamicDescriptor" />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}>
            <ControlledTextField
              isDisabled={loading}
              disableDefaultMargins
              label="ZenDesk Url"
              fieldKey="zenDeskUrl"
              formControl={form.control}
              extraValidationRules={{
                pattern: validationUtil.reUrl
              }} />
          </Grid>

          <Grid
            item
            xs={12}>
            <ControlledTextField
              isDisabled={loading}
              disableDefaultMargins
              label="Additional Support Text"
              formControl={form.control}
              numLines={5}
              extraValidationRules={{
                maxLength: 10000
              }}
              fieldKey="additionalSupportText" />
          </Grid>
        </Grid>
      </BaseWidget.FC>
    </Form.FC>
  );
};
